import React from "react";

const NewServiceTabMobile = ({ selected, onSelect }) => {
  const sections = [
    { id: "basic", label: "Basic details", badge: "Updated" },
    { id: "team", label: "Team members" },
    { id: "resources", label: "Resources" },
    { id: "addons", label: "Service add-ons" },
    { id: "online", label: "Online booking" },
    { id: "forms", label: "Forms", badge: 1 },
    { id: "commissions", label: "Commissions" },
    { id: "settings", label: "Settings" },
  ];

  return (
    <div className="md:hidden bg-dry overflow-x-auto">
      <div className="flex space-x-6 px-4">
        {sections.map((item) => (
          <button
            key={item.id}
            onClick={() => onSelect(item.id)}
            className={`relative py-3 text-sm whitespace-nowrap font-medium ${
              selected === item.id
                ? "text-yellowstar bg-navy rounded-full px-5"
                : "text-textGray hover:text-black"
            }`}
          >
            {item.label}
            {item.badge && (
              <span className="ml-2 text-xs bg-gray-200 text-gray-700 rounded-full px-2 py-0.5">
                {item.badge}
              </span>
            )}
            {selected === item.id && (
              <span className="absolute bottom-0 left-0 right-0 h-[0px] bg-black rounded-full" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NewServiceTabMobile;
